// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"141":"history","489":"prayers","655":"zikr","721":"zikr-app","884":"admin","933":"auth"}[chunkId] + "." + {"141":"79ea1d91","489":"66814795","655":"e9028e95","721":"11566a55","884":"4ef8b5f6","933":"ce9e94ff"}[chunkId] + ".css";
};